import adiStatementDetailsHandler from "@NA/Handlers/ADIStatementDetailsHandler";
import adiViewMyStatementsHandler from "@NA/Handlers/ADIViewMyStatementsHandler";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import ADIColors from "@NA/Utils/ADIColors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import siteMessage from "@insite/client-framework/SiteMessage";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { StyledButton } from "@insite/mobius/Clickable";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link from "@insite/mobius/Link";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import Typography from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import getColor from "@insite/mobius/utilities/getColor";
import React, { FC, useState } from "react";
import { ResolveThunks, connect } from "react-redux";
import { css } from "styled-components";
interface OwnProps extends WidgetProps {
}

const mapStateToProps = (state: CustomApplicationState) => {
    const cart = getCurrentCartState(state)
    const billToState = getBillToState(state, cart?.value?.billToId);
 return {
        billToState,
    };
};

const mapDispatchToProps = {
    adiViewMyStatementsHandler,
    adiStatementDetailsHandler
};

export interface AdiViewMyStatementsStyles {
    viewMyStatementMainContainer?: GridContainerProps;
    viewMyStatementGridItem?: GridItemProps;
    viewMyStatementsContainer?: InjectableCss;
}

export const adiViewMyStatementsStyles: AdiViewMyStatementsStyles = {
    viewMyStatementMainContainer: {
        css: css`
            >${GridOffset}{
                background: ${getColor("common.background")};
            }
        `
    },
    viewMyStatementGridItem: {
        width: 12
    },
    viewMyStatementsContainer: {
        css: css`
        width: 100%;
            .viewstatements{
                .viewMyStatementsHeading{
                    font-size: 20px; 
                    margin-top: 10px;
                }
                .customerInfoDiv{
                    font-size: 14px;
                    margin-left: 10px;
                    h3{
                        border-bottom: 1px solid ${getColor("common.border")};
                        font-size: 1.2em;
                        margin-top: 1.25em;
                        margin-bottom: 0.8em;
                        font-weight: bold;
                        line-height: 1.4;
                        padding-bottom: 5px;
                    }
                    .customerNumberValue{
                        margin-left: 40px;
                    }
                    .companyNameValue{
                        margin-left: 53px;
                    }
                    .addressValue{
                        margin-left: 98px;
                    }
                    .cityValue{
                        margin-left: 156px;
                    }
                }
                .availableStatementsText{
                    background: ${ADIColors.blue4}; 
                    height: 28px; 
                    margin-top: 30px;
                    span{
                        color: ${getColor("common.background")}; 
                        font-size: 16px; 
                        font-weight: normal; 
                        vertical-align: middle; 
                        padding: 5px 5px 5px 13px;
                    }
                }
                .availableStatementsError{
                    span{
                        padding: 0.25em 1em;
                        font-size: 0.9em;
                        line-height: 1.5em;
                        font-weight: 600;
                        display: block;
                        margin-top: -1px;
                        margin-bottom: 1rem;
                        font-style: italic;
                        background: ${ADIColors.lightRed};
                        color: ${getColor("common.background")};
                    }
                }
                .statementListsContainer{
                    width: 100%;
                    display: flex;
                    @media only screen and (max-width: 767px) {
                        flex-direction: column;
                    }
                }
                .statementLists{
                    list-style-type: none; 
                    font-size: 15px; 
                    font-weight: normal; 
                    color: ${ADIColors.black2}; 
                    line-height: 1.5; 
                    list-style: none; 
                    vertical-align: middle; 
                    padding: 0; 
                    margin: 0;
                    width: 25%;
                    display: flex;
                    flex-direction: column;
                    @media only screen and (max-width: 767px) {
                        width: 100%;
                    }
                    > li:nth-child(odd){
                        background: ${ADIColors.lightGrey1}; 
                    }
                    li{
                        padding: 10px 10px 10px 13px;
                        >${StyledButton}{
                            &:focus{
                                outline: none;
                            }
                            >${TypographyStyle}{
                                font-size: 16px;
                                font-weight: normal;
                                color: ${ADIColors.lightblue4};
                                text-transform: capitalize;
                                &:hover{
                                    text-decoration: underline;
                                }
                            }
                        }
                    }
                }
            }
        `
    }
};

const styles = adiViewMyStatementsStyles;

type Props =OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> ;

const ADIViewMyStatements: FC<Props> = ({ adiViewMyStatementsHandler, billToState, adiStatementDetailsHandler,id}) => {
    const [datesByYear, setDatesByYear] = useState<Object>({});
    const [errorMsg, setErrorMsg] = useState<string>("");
    const [isLoading, setIsLoading] = useState(false);

    React.useEffect(() => {
          adiViewMyStatementsHandler({
            onSuccess: (result: any) => {
                const dates = result?.statementDates || [];
                const groupedDates = groupDatesByYear(dates);
                setDatesByYear(groupedDates);
            }
        });
    }, []);

    const OpenPDF = (statementNo: string, pdfString: string) => {
        var byteCharacters = atob(pdfString);
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        var blob = new Blob([byteArray], {
            type: 'application/pdf'
        });
        var nav = window.navigator as Navigator & { msSaveOrOpenBlob?: Function };
        if (window.navigator && nav.msSaveOrOpenBlob) {
            nav.msSaveOrOpenBlob(blob, statementNo + ".pdf");
        } else {
            var objectUrl = URL.createObjectURL(blob);
            window.location.assign(objectUrl)
        }
    }

    const getStatementsDetails = (statementNumber: string | any) => {
        setIsLoading(true);
        const updatedDate = new Date(statementNumber);
        const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
        const formattedDate = updatedDate.toLocaleDateString('en-US', options).replace(',', '').split(' ');
        const modifiedDate = `${formattedDate[0]} ${formattedDate[2]} ${formattedDate[1]}`;
        adiStatementDetailsHandler({
            statementNo: modifiedDate,
            onSuccess: (result: any) => {
                setIsLoading(false);
                OpenPDF(modifiedDate, result?.pdfString);
            },
            onError: (error: any) => {
                setErrorMsg(error?.errorMessage);
                setIsLoading(false);
            }
        })
    }

    const groupDatesByYear = (dates: string[]) => {
        const groupedValues: { [key: string]: string[] } = {};
        const currentYear = new Date().getFullYear();
        dates.forEach(date => {
            const year = new Date(date).getFullYear().toString();
            if (currentYear - parseInt(year) < 4) {
                if (!groupedValues[year]) {
                    groupedValues[year] = [];
                }
                groupedValues[year].push(date);
            }
        });
        return groupedValues;
    };

    const formatDate = (inputDate: string) => {
        const options: Intl.DateTimeFormatOptions = { month: 'long', year: 'numeric' };
        const formattedDate = new Date(inputDate).toLocaleDateString(undefined, options);
        return formattedDate;
    }

    return (
<StyledWrapper>
<LoadingOverlay loading={isLoading} spinnerProps={{ color: "primary" }}>
            <GridContainer {...styles.viewMyStatementMainContainer}>
                <GridItem {...styles.viewMyStatementGridItem}>
                    <StyledWrapper {...styles.viewMyStatementsContainer}>
                        <StyledWrapper className="viewstatements">
                            <StyledWrapper className="viewMyStatementsHeading">
                                {translate("View My Statements")}
                            </StyledWrapper>
                            <StyledWrapper className="customerInfoDiv">
                                <Typography as="h3">{translate("Customer Information")}</Typography>
                                <Typography as="span">{translate("Customer Number")}:</Typography>
                                <Typography as="span" className="customerNumberValue">
                                    {billToState.value?.customerNumber}
                                </Typography><br />
                                <Typography as="span">{translate("Company Name")}:</Typography><Typography as="span" className="companyNameValue">
                                    {billToState.value?.companyName}
                                </Typography><br />
                                <Typography as="span">{translate("Address")}:</Typography><Typography as="span" className="addressValue">
                                    {billToState.value?.address1} {billToState.value?.address2}
                                </Typography><br />
                                <Typography as="span" className="cityValue">
                                    {billToState.value?.city},&nbsp;{billToState.value?.state?.abbreviation}&nbsp;
                                    {billToState.value?.postalCode}
                                </Typography>
                            </StyledWrapper>
                            <StyledWrapper className="availableStatementsDiv">
                                <StyledWrapper className="availableStatementsText">
                                    <Typography as="span">
                                        {translate("Available Statements")}
                                    </Typography>
                                </StyledWrapper>
                                {errorMsg !== "" &&
                                    <StyledWrapper className="availableStatementsError">
                                        <Typography as="span">{translate(`${errorMsg}`)}</Typography>
                                    </StyledWrapper>
                                }
                                <StyledWrapper className="statementListsContainer">
                                    {Object.entries(datesByYear).sort(([yearA], [yearB]) => parseInt(yearB) - parseInt(yearA)).map(([year, statements]: any) => (
                                        <ul className="statementLists">
                                            {statements.map((statement: string, index: number) => (
                                                <li key={index}>
                                                    <Link onClick={() => getStatementsDetails(statement)}>
                                                        {formatDate(statement)}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    ))}
                                </StyledWrapper>
                            </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>
                </GridItem>
            </GridContainer>
        </LoadingOverlay>
        <Zone contentId={id} zoneName="Content1" />
        </StyledWrapper>
);
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ADIViewMyStatements),
    definition: {
        group: "Basic",
        displayName: "ADI View My Statements"
    },
};

export default widgetModule;
